import { countTourTargets } from './AnchoredTourGuide';

export const getFormTourRowCountBaselineStorageKey = (tourStorageKey: string) =>
  `${tourStorageKey}-row-count-baseline`;

export const ADD_SENDER_ACCOUNT_OAUTH_SUCCESS_KEY = 'onboarding-add-sender-account-oauth-success';

export const persistFormTourRowCountBaseline = (tourStorageKey: string, testIds: readonly string[]) => {
  sessionStorage.setItem(
    getFormTourRowCountBaselineStorageKey(tourStorageKey),
    String(countTourTargets(testIds)),
  );
};

export const readFormTourRowCountBaseline = (tourStorageKey: string): number | null => {
  const stored = sessionStorage.getItem(getFormTourRowCountBaselineStorageKey(tourStorageKey));

  if (stored === null) {
    return null;
  }

  const parsed = Number.parseInt(stored, 10);

  return Number.isNaN(parsed) ? null : parsed;
};

export const clearFormTourRowCountBaseline = (tourStorageKey: string) => {
  sessionStorage.removeItem(getFormTourRowCountBaselineStorageKey(tourStorageKey));
};
